import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMandatory = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 4C10.4608 4 10.833 4.38304 10.833 4.85714V8.48661L13.7356 6.69464C14.1313 6.45089 14.6415 6.58214 14.8784 6.98929C15.1153 7.39643 14.9877 7.92143 14.592 8.16518L11.6192 10L14.5946 11.8375C14.9903 12.0813 15.1179 12.6062 14.881 13.0134C14.6441 13.4205 14.1339 13.5518 13.7382 13.308L10.833 11.5134V15.1429C10.833 15.617 10.4608 16 10 16C9.53924 16 9.16698 15.617 9.16698 15.1429V11.5134L6.26443 13.3054C5.86874 13.5491 5.35852 13.4179 5.12163 13.0107C4.88474 12.6036 5.01229 12.0786 5.40798 11.8348L8.38082 10L5.40537 8.1625C5.00969 7.91875 4.88213 7.39375 5.11902 6.98661C5.35591 6.57946 5.86614 6.44821 6.26182 6.69196L9.16698 8.48661V4.85714C9.16698 4.38304 9.53924 4 10 4Z",
		fill: "#D42A36"
	})
});
export default SvgMandatory;
